import React, { useEffect, useState, useRef } from "react";
import "./extraoffer.css";
import { Link } from "react-router-dom";
import "../dailyBestSells/dailybestsells.css"
import Button from "@mui/material/Button";  

const ExtraOffer = () =>{
    
      const [time, setTime] = useState({
        days: 7,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0,
      });
    
      const intervalRef = useRef(null);
    
      useEffect(() => {
        intervalRef.current = setInterval(() => {
          setTime((prevTime) => {
            let { days, hours, minutes, seconds, milliseconds } = prevTime;
    
            if (
              days === 0 &&
              hours === 0 &&
              minutes === 0 &&
              seconds === 0 &&
              milliseconds === 0
            ) {
              clearInterval(intervalRef.current);
              return prevTime;
            }
    
            if (milliseconds === 0) {
              milliseconds = 99;
              if (seconds === 0) {
                seconds = 59;
                if (minutes === 0) {
                  minutes = 59;
                  if (hours === 0) {
                    hours = 23;
                    days -= 1;
                  } else {
                    hours -= 1;
                  }
                } else {
                  minutes -= 1;
                }
              } else {
                seconds -= 1;
              }
            } else {
              milliseconds -= 1;
            }
    
            return { days, hours, minutes, seconds, milliseconds };
          });
        }, 10);
    
        return () => clearInterval(intervalRef.current);
      }, []);
    
      const { days, hours, minutes, seconds, milliseconds } = time;
    

    return(
        <>
          <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12">
                <div className="heading_common pt_10">
                     <h3> Extra Offers</h3>
                 </div>
                </div>
            </div>
        </div>
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-12 mt_15">
                <div class="offers_box">
                <div class="offer_card1">
                 <div class="offer_content">
                    <h2>Coffee Combo Pack <span className="common_color">Offer</span></h2>
                    <p>Time remaining until the end of the offer.</p>
                    <div className="best_sells_timer">
                    {days === 0 &&
                    hours === 0 &&
                    minutes === 0 &&
                    seconds === 0 &&
                    milliseconds === 0 ? (
                      <h1>Busted!</h1>
                    ) : (
                      <div className="time-box-wrapper">
                        <div className="single-box">
                          <h6>{days} D</h6>
                          <span>:</span>
                        </div>
                        <div className="single-box">
                          <h6>{hours} H</h6>
                          <span>:</span>
                         </div>
                        <div className="single-box">
                          <h6>{minutes} M</h6>
                          <span>:</span>
                         </div>
                        <div className="single-box">
                          <h6>{seconds} S</h6>
                          <span>:</span>
                         </div>
                        <div className="single-box">
                          <h6>{milliseconds} MS</h6>
                          </div>
                      </div>
                    )}
                  </div>
                  <div className="common_btn_box btn_best_sells">
                     <Button ><Link to="searchproductlist" class="common_btn_shop "> Shop Now</Link></Button>
                 </div>
                </div>
                </div>
                </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-12 mt_15">
                <div class="offers_box">
                <div class="offer_card2">
                <div class="offer_content">
                    <h2> Cloaths Combo Box <span className="common_color">Offer</span></h2>
                    <p>Time remaining until the end of the offer.</p>
                      <div className="best_sells_timer">
                    {days === 0 &&
                    hours === 0 &&
                    minutes === 0 &&
                    seconds === 0 &&
                    milliseconds === 0 ? (
                      <h1>Busted!</h1>
                    ) : (
                      <div className="time-box-wrapper">
                        <div className="single-box">
                          <h6>{days} D</h6>
                          <span>:</span>
                        </div>
                        <div className="single-box">
                          <h6>{hours} H</h6>
                          <span>:</span>
                         </div>
                        <div className="single-box">
                          <h6>{minutes} M</h6>
                          <span>:</span>
                         </div>
                        <div className="single-box">
                          <h6>{seconds} S</h6>
                          <span>:</span>
                         </div>
                        <div className="single-box">
                          <h6>{milliseconds} MS</h6>
                          </div>
                      </div>
                    )}
                  </div>
                  <div className="common_btn_box btn_best_sells">
                     <Button ><Link to="searchproductlist" class="common_btn_shop "> Shop Now</Link></Button>
                 </div>
                </div>
                </div>
                </div>
            </div>
             </div>
            </div>
        

        </>
    )
}

export default ExtraOffer;